export default {
  importTrackingNumbers: {
    id: 'bo_sellers-orders-drawers-import_csv_file-import_tracking_numbers',
    defaultMessage: 'Import tracking numbers',
  },
  importIMEIs: {
    id: 'bo_sellers-orders-drawers-import_csv_file-import_imeis',
    defaultMessage: 'Import IMEIs',
  },
  importIMEIsDescription: {
    id: 'bo_sellers-orders-drawers-import_csv_file-import_imeis-description',
    defaultMessage: 'For smartphone orders only',
  },
} as const
